import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$lang/_layout/explore/$city/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$lang/$city/$category/$slug",
      params: {
        lang: params.lang,
        city: params.city,
        category: "place",
        slug: params.slug,
      },
      replace: true,
      statusCode: 301,
    });
  },
  component: () => null,
});
